import React from 'react'
import Layout from '../../../../components/Layout'
import styled from 'styled-components'

export default function Map ({ name, isLoading }) {
 
  const url = `https://www.google.com/maps/embed/v1/place?q=${name}&key=AIzaSyDzBIv9wAiPq4JQ68Bn5e-iCD2_SC_ihRc`
  return (
    <Container>
      {isLoading ? (
        <LoaderContainer>
          <Layout.Loader loading={isLoading}/>
        </LoaderContainer>
      ) : null}
      <iframe src={url} width="100%" height="450" style={{ borderRadius: 12, border: 0 }} key={url} />
    </Container>
  )
}

const LoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-text: center;
  align-items: center;
  height: 450px;
  width: 100%;
`

const Container = styled.div` 
  background: #FFF;
  box-shadow: 0 3px 20px rgba(197, 217, 232, 0.5);
  border-radius: 12px;
  height: 450px;
`
